
import { defineComponent } from 'vue'
import { mapActions } from 'vuex'
import { OrgGroupsActions } from '~/store/control-panel/groups'

export default defineComponent({
  name: 'ControlPanelGroupInviteModal',

  props: {
    groupId: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      showGroupInviteModal: false
    }
  },

  methods: {
    ...mapActions('control-panel/groups', {
      updateOrgGroup: OrgGroupsActions.UPDATE_GROUP
    }),
    showModal(): void {
      this.showGroupInviteModal = true
    }
  }
})
